export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7f7bca9181df0540b8adfcea3e2119354dd01be614&name=fetchTypeahead!'